import React from 'react';
import {
	ToothPathology,
	ToothRestorationFilling,
} from '../../../../graphql/graphql';
import { ToothViewData } from '../Tooth/teethData';
import DENTToothRestorationFillingSurface from './DENTToothRestorationFillingSurface';

interface Props {
	fillings?: ToothRestorationFilling[];
	toothViewData: ToothViewData;
	pathology: ToothPathology;
}

const DENTToothRestorationFillingSurfaces = ({
	fillings,
	toothViewData,
	pathology,
}: Props) => {
	if (!fillings) {
		return <></>;
	}

	return (
		<>
			{fillings.map(filling =>
				filling.surfaces.map((surface, index) => (
					<DENTToothRestorationFillingSurface
						key={index}
						toothViewData={toothViewData}
						surface={surface}
						pathology={pathology}
						values={filling.values}
					/>
				)),
			)}
		</>
	);
};

export default DENTToothRestorationFillingSurfaces;
